import type { Action } from 'redux';
import type { Task } from 'redux-saga';
import { type ActionPattern, call, cancel, type ForkEffect, fork, take } from 'redux-saga/effects';

export function takeLatestUniqBy<A extends Action, P extends ActionPattern, Args extends unknown[]>(
  keyExtractor: (action: A) => string,
  patternOrChannel: P,
  saga: (action: A, ...args: Args) => unknown,
  ...args: Args
): ForkEffect<void> {
  return fork(function* () {
    const tasks = new Map<string, Task>();

    while (true) {
      const action: A = yield take(patternOrChannel);
      const taskKey = keyExtractor(action);

      yield fork(function* () {
        const task = tasks.get(taskKey);

        if (task) {
          yield cancel(task);
        }

        tasks.set(
          taskKey,
          yield fork(function* () {
            yield call(saga, action, ...args);

            tasks.delete(taskKey);
          }),
        );
      });
    }
  });
}
